import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 2rem;
`
